import { differenceInDays } from 'date-fns';

export const getTokenExpiresDate = (exp: number) => {
  return new Date(exp * 1000);
};
export const isTokenExpires = (exp: number) => {
  return differenceInDays(getTokenExpiresDate(exp), new Date()) <= 2;
};
